var App = (function () {
  'use strict';

  App.expenses = function() {
    var formExpense = {
      id: 'form-expense',
      headerSelector: '.js-form-expense__header',
      submitButtonSelector: '.js-form-expense__submit-button',
    };
    var iconEditExpenseSelector = '.js-expense__icon-edit';
    var buttonAddExpenseSelector = '.js-expenses__add-button';
    var expensesTableClass = 'js-expenses-table';
    var expensesTableSelector = '.' + expensesTableClass;
    var expensesStartDateSelector = '#expenses_start_date';
    var expensesEndDateSelector = '#expenses_end_date';
    var formsSelectors = ['#mod-delete', '#form-expense'];

    var $expensesTable = $(expensesTableSelector);
    if(!$expensesTable.length) {
      return;
    }

    var $expensesSearchInput = $('.js-expenses-table__search');
    var $expensesAmount = $('.expenses-amount__value');

    var expensesTable = createExpensesDatatable($expensesTable);
    initExpenseEditForm(expensesTable);
    initAddingExpenseForm();
    initExpensesSearch($expensesSearchInput, expensesTable);
    initExpensesDateFilter(expensesTable);
    initTableReload(expensesTable, formsSelectors);
    initExpensesButtons(expensesTable);

    function createExpensesDatatable($table) {

      var columnNamesForExport = [
        'datetime:name',
        'amount:name',
        'type_name:name',
        'event_type:name',
        'event_name:name',
        'comment:name'
      ];

      var table = $table.DataTable({
        dom:  "<'row be-datatable-body'<'col-sm-12'tr>>" +
              "<'row be-datatable-footer'<'col-sm-2'l><'col-sm-4'i><'col-sm-6'p>>",
        order: [],
        ajax: {
          url: '/json/crm_handler/',
          type: 'POST',
          data: {
            method: "GetExpenses",
          }
        },
        columns: [
          {
            data: 'id',
            orderable: false,
            searchable: false,
            className: 'actions',
            render: function (data, type, full, meta) {
              return type === 'display' ?
                '<i class="icon mdi mdi-edit js-expense__icon-edit" data-toggle="modal" data-target="#form-expense"></i>' :
                data;
            },
          },
          {
            data: 'datetime',
            render: function (data, type, full, meta) {
              if (!data) {
                return '';
              }

              return type === 'display' ? moment(data).format('ll') : data;
            },
          },
          {
            data: 'amount',
            className: 'number',
            render: function (data, type, full, meta) {
              return type === 'display' ? '<b>' + parseInt(data).toLocaleString() + '</b>' :  data;
            },
          },
          { data: 'type_name' },
          { data: 'event_type' },
          {
            data: 'event_link',
            render: function (data, type, full, meta) {
              if (!data) {
                return '';
              }

              return type === 'display' ?
                '<a href="' + data + '">' + full.event_name + '</a>' :
                full.event_name;
            }
          },
          { data: 'comment' },
          {
            data: 'id',
            orderable: false,
            searchable: false,
            className: 'actions',
            render: function (data, type, full, meta) {
              return type === 'display' ?
                '<i class="icon mdi mdi-delete js-delete-item" data-delete-id="' + data + '" data-toggle="modal" data-target="#mod-delete" data-method="DeleteExpense"></i>' :
                data;
            },
          },
        ],
        buttons: [
          {
            extend: 'excel',
            name: 'excel',
            text: '<span class="icon mdi mdi-file"></span>',
            filename: 'расходы',
            exportOptions: {
              columns: columnNamesForExport,
              orthogonal: 'export',
              modifier: {
                page: 'all',
                selected: false,
              }
            }
          }
        ],
        drawCallback: function () {
          var api = this.api();
          var amount = api.column('amount:name', {search: 'applied'}).data().reduce(function(acc, current) {
            return acc + parseInt(current);
          }, 0);
          var amountText = '- ' + amount.toLocaleString() + " " + String.fromCharCode(8381);

          $expensesAmount.text(amountText);
        }
      });

      return table;
    }

    function initExpenseEditForm(table) {
      $(expensesTableSelector + ' tbody').on('click', iconEditExpenseSelector, function () {
        var tr = $(this).closest('tr');
        var row = table.row(tr);
        var form = document.getElementById(formExpense.id);
        var formFields = form.elements;

        var expenseId = row.data().id;
        var datetime = row.data().datetime;
        var amount = row.data().amount;
        var type = row.data().type;
        var eventId = row.data().event_id;
        var comment = row.data().comment;

        $(formExpense.headerSelector).text('Редактирование расхода');
        $(formExpense.submitButtonSelector).text('Изменить');

        formFields['method'].value = 'UpdateExpense';
        formFields['expense_id'].value = expenseId;
        formFields['datetime'].value = datetime;
        formFields['amount'].value = amount;
        formFields['type'].value = type;
        $(formFields['type']).trigger('change');
        formFields['course_id'].value = eventId;
        $(formFields['course_id']).trigger('change');
        formFields['comment'].value = comment;
      });

      initEventSelectionField();
      initTypeSelectionField();

      function initEventSelectionField() {
        var events = $(".js-form-expense__events").select2({
          width: '100%',
          placeholder: 'Выбрать...',
        });
      }

      function initTypeSelectionField() {
        var events = $(".js-form-expense__type").select2({
          width: '100%',
          placeholder: 'Выбрать...',
        });
      }
    }

    function initAddingExpenseForm() {
      $(buttonAddExpenseSelector).click(function() {
        //var formSelector = $(this).attr('data-target');
        resetFormExpense();
      });

      function resetFormExpense() {
        var form = document.getElementById(formExpense.id);
        var formFields = form.elements;

        $(formExpense.headerSelector).text('Добавление расхода');
        $(formExpense.submitButtonSelector).text('Добавить');
        form.reset();

        formFields['datetime'].value = getCurrentDate();
        formFields['method'].value = 'CreateExpense';
        formFields['expense_id'].value = '';
        formFields['type'].value = null;
        $(formFields['type']).trigger('change');
        formFields['course_id'].value = null;
        $(formFields['course_id']).trigger('change');
      }

      function getCurrentDate() {
        var today = new Date();
        var day = today.getDate();
        var dd = day < 10 ? '0' + day : day;
        var month = today.getMonth() + 1;
        var mm = month < 10 ? '0' + month : month;
        var yyyy = today.getFullYear();

        return yyyy + '-' + mm + '-' + dd;
      }
    }

    function initExpensesSearch(searchInput, table) {
      searchInput.on('keyup click', function () {
        table.search(searchInput.val()).draw();
      });
    }

    function initExpensesDateFilter(table) {
      var startDateInput = $(expensesStartDateSelector);
      var endDateInput = $(expensesEndDateSelector);

      initDateInput(startDateInput);
      initDateInput(endDateInput);

      addDateRangeFilterToTable(table, startDateInput, endDateInput);

      function initDateInput(inputField) {
        // Remove build-in theme datetimepicker
        inputField.datetimepicker('remove');

        // Init new datetimepicker
        inputField
          .datetimepicker({
            format: 'yyyy-mm-dd',
            minView: 2,
            language: 'ru',
            autoclose: true,
            todayHighlight: true,
            navIcons:{
              rightIcon: 'mdi mdi-chevron-right',
              leftIcon: 'mdi mdi-chevron-left'
            }
          });
          /*.on('changeDate', function(ev){
            table.draw();
        });*/
        inputField.change(function() {
          table.draw();
        });
      }
    }

    function addDateRangeFilterToTable(table, startDateInput, endDateInput) {
      $.fn.dataTable.ext.search.push(
        function(settings, data, dataIndex) {
          var isExpensesTable = settings.nTable.className.includes(expensesTableClass);
          if (!isExpensesTable) {
            return true;
          }

          var start = startDateInput.val(),
            end = endDateInput.val();
          if (start) {
            start += ' 00:00:00';
          }
          if (end) {
            end += ' 23:59:59';
          }

          var startDate = moment(start);
          var endDate = moment(end);
          if (!startDate.isValid() && !endDate.isValid()) {
            return true;
          }

          var idx = table.column('datetime:name').index();
          var date = moment(data[idx]);

          if (!date.isValid()) {
            return false;
          }

          if ((!startDate.isValid() && date.isSameOrBefore(endDate)) ||
              (date.isSameOrAfter(startDate) && !endDate.isValid()) ||
              (date.isSameOrAfter(startDate) && date.isSameOrBefore(endDate)))
          {
              return true;
          }

          return false;
        }
      );
    }

    function initTableReload(table, formsSelectors) {
      formsSelectors.forEach(function(formSelector) {
        var $form = $(formSelector);
        $form.bind('success', function(){
          $form.modal('toggle');
          table.ajax.reload(null, false);
        });
      });
    }

  };

  function initExpensesButtons(table) {
    initExpensesExportButton(table);
  }

  function initExpensesExportButton(table) {
    var exportButton = $('.js-button-export-excel-expenses');
    exportButton.click(function() {
      table.buttons('excel:name').trigger();
    });
  }

  return App;
})(App || {});
